import { render, staticRenderFns } from "./performance-cmc-documentation.vue?vue&type=template&id=47709fb2"
import script from "./performance-cmc-documentation.vue?vue&type=script&lang=js"
export * from "./performance-cmc-documentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports